$mol_view_tree2_to_js_test_ex_bidi_chaining_foo $mol_object
	a? <=> b? <=> c? null
